var config = require('../config').config;

function update() {
    if (window.dataLayer && config.location) {
        window.dataLayer.push({
            event: "location",
            location: {
                alpha2: config.location.alpha2,
                continent: config.location.continent,
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', update);
module.exports.update = update;